import {SET_NOTIFICATIONS} from "./notifications-types";

const initialState = {
  notifications: []
}

export const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATIONS: return {...state, notifications: action.notifications}
    default: return state
  }
}